/*
 * @Author: tingtinggao
 * @Date: 2022-11-03 16:41:16
 * @LastEditors: tingtinggao
 * @LastEditTime: 2022-11-24 16:46:26
 * @FilePath: \bmp-front\src\api\purchaseSalesCenter\project.js
 * @Description:
 *
 */
export default {
  // 项目立项列表
  PROJECT_List: '/sales/projectInitiation/page',
  // 专门给采购合同使用的
  PROJECT_LIST1: '/sales/projectInitiation/purchaseContractPage',
  // 招标完成
  BID_FINISH: '/sales/projectInitiation/bidComplete',
  // 导出立项
  EXPORT_PROJECT: '/sales/projectInitiation/exportProjectInitiation',
  // 新的导出
  NEW_EXPORT_PROJECT: '/sales/projectInitiation/export',
  // 关闭立项
  CLOSE_PROJECT: '/sales/projectInitiation/closeProjectInitiationById',
  // 取消关闭立项
  CANCEL_CLOSE_PROJECT: '/sales/projectInitiation/cancelCloseProjectInitiationById',
  // 删除立项
  DELETE_PROJECT: '/sales/projectInitiation/deleteProjectInitiationById',
  // 保存立项
  SAVE_PROJECT: '/sales/projectInitiation/save',
  // 提交立项
  SUBMIT_PROJECT: '/sales/projectInitiation/submitProjectInitiation',
  // 批量提交审批
  SUBMIT_APROVER: '/sales/projectInitiation/batchSubmitProjectInitiation',
  // 立项详情查询
  PROJECT_DETAIL: '/sales/projectInitiation/selectProjectInitiationById',
  // 撤销
  WITHDRAW: '/sales/projectInitiation/withdraw',
  // 获取基地下拉数据
  CUSTOMER_ADDRESS: '/sales/order/getCustomerAddressInfo',
  // 保存运管审批人
  SAVE_APPROVER: '/sales/projectInitiation/updateOperationManagementCenterById',
};
